import { create } from "zustand";
import { fireWaba, getWabaList, postWaba, putWaba } from '../api';
import { toast } from 'react-toastify';

export const useWabaMessageList = create((set, get) => ({
  wabaList: [],
  pageCount: 1,
  fetchWabaList: async ({pageNo = 1, searchKey}) => {
    try {
        const response = await getWabaList(pageNo, searchKey);
        const {data, pageCount} = response.data;
        set({wabaList: data, pageCount: pageCount})
    } catch (error) {
        console.error(error);
    } 
  },
  updateWaba: async(id, body) => {
    try {
        await putWaba(id, body);
        get().fetchWabaList({pageNo:1});
        toast.success('WABA Updated');
    } catch (error) {
        toast.error('Failed to create WABA');
        console.error(error);
    }
  },
  createWaba: async(body) => {
      try {
        await postWaba(body)
        get().fetchWabaList({pageNo:1});
        toast.success('WABA Created');
      } catch (error) {
        toast.error('Failed to Update WABA');
        console.error(error);
    }
  },
  sendWaba: async(body) => {
    try {
      await fireWaba(body);
      toast.success('WABA Created');
    } catch (error) {
      toast.error('Failed to Send WABA');
      console.error(error);
    }
  }
}));